import SSOConf from '@/constants/SSOConf';
import { QUERY_KEYS } from '@/v2/constants/QueryKeys';
import { SSO_ALREADY_REDIRECTED_KEY } from '@/v2/domains/Auth/constants/constants';

// The new react-queries don't use the SSOContext nor pendingRedirect
// the auth flow is managed with /callback and params redirectTo and redirectErrorTo
export default function onSSOError({ error, router, queryClient }) {
  const user = queryClient.getQueryData([QUERY_KEYS.ME]);
  const provider = error?.response?.headers?.['x-integration-provider'];

  const isReturningFromSSO =
    sessionStorage.getItem(SSO_ALREADY_REDIRECTED_KEY) === 'true';

  if (isReturningFromSSO || !provider) {
    router.push('/auth/ssoError');
    sessionStorage.removeItem(SSO_ALREADY_REDIRECTED_KEY);
    return;
  }

  const loginUrl = SSOConf[provider].getLoginUrl({
    user,
    redirectTo: window.location.href,
    redirectErrorTo: '/auth/ssoError',
  });
  sessionStorage.setItem(SSO_ALREADY_REDIRECTED_KEY, 'true');
  router.push(loginUrl);
}
